import {
	AssetPipeSummary,
	AssetPipeSummaryResolvedResponse,
} from '@Types/asset.types';
import { formatYearFieldValue } from '@Utils';
import { centreExtent, geometriesExtent } from '@innovyze/shared-utils';
import {
	getAssetPipe,
	getAssetPipeRejected,
	getAssetPipeResolved,
} from '@Actions/assetPipe.actions';
import { mapMainPosition, mapMainSelection } from '@Actions/map.actions';
import { put, retry, takeLatest } from 'redux-saga/effects';

import { AnyAction } from 'redux';
import { AxiosResponse } from 'axios';
import { MapPosition } from '@innovyze/inno-map';
import { getSummaryApi } from '@Services';

// TODO make it generic @AssetSchemaMigration
function* getAssetPipeSaga(action: AnyAction) {
	try {
		const payload: AxiosResponse<AssetPipeSummaryResolvedResponse> =
			yield retry(5, 15000, getSummaryApi, action.payload);

		const result = payload.data;
		if (
			payload.data.asset &&
			payload.data.asset.segments &&
			payload.data.asset.segments.length == 1
		) {
			const segment = payload.data.asset.segments[0];
			result.asset.material = segment.material as string;
			result.asset.diameter = segment.width as number;
		}

		if (payload.data.asset) {
			// Hardcoded on purpose - unlike isYearField in the Properties panel,
			// this list won't auto-cover a new year* field added to the schema.
			if (payload.data.asset['yearLaid']) {
				payload.data.asset['yearLaid'] =
					formatYearFieldValue(payload.data.asset['yearLaid']) ?? '';
			}

			if (payload.data.asset['yearInstalled']) {
				payload.data.asset['yearInstalled'] =
					formatYearFieldValue(payload.data.asset['yearInstalled']) ??
					'';
			}

			if (payload.data.asset['yearRenewed']) {
				payload.data.asset['yearRenewed'] =
					formatYearFieldValue(payload.data.asset['yearRenewed']) ?? '';
			}
		}
		yield put(getAssetPipeResolved(result));
	} catch (_e) {
		yield put(getAssetPipeRejected());
	}
}

function* watchGetAssetPipe() {
	yield takeLatest(getAssetPipe, getAssetPipeSaga);
}

function* getAssetPipeResolvedSaga(action: AnyAction) {
	const asset: AssetPipeSummary = action.payload.asset;
	if (asset) {
		const extent = asset.geometry
			? geometriesExtent([asset.geometry])
			: undefined;
		const center = centreExtent(extent);

		if (center) {
			const position: MapPosition = {
				center,
				zoom: 15,
			};

			yield put(mapMainPosition(position));
		}

		yield put(
			mapMainSelection([
				{ id: asset.assetId, layerId: 'risk_levels_medium' },
			]),
		);
	}
}

function* watchGetAssetPipeResolved() {
	yield takeLatest(getAssetPipeResolved, getAssetPipeResolvedSaga);
}

export default [watchGetAssetPipe(), watchGetAssetPipeResolved()];
